export default __webpack_public_path__ + "static/media/transation-active.fdf5844d.svg";